<template>
  <Authenticated>
    <section v-for="site in siteMap" :key="site.site" class="main">
      <h2>{{ site.site }}</h2>
      <div class="unit-container">
        <div
          v-for="station in site.stations.mon"
          :key="station.name"
          class="unit"
          @click.stop.prevent="openMONModal(station)"
        >
          <h4>{{ station.name }}</h4>
          <p class="type-label">Temperature Monitor</p>
        </div>
        <div class="new" @click.stop.prevent="openMONModal(site.site, true)">
          Add MON Station
        </div>
      </div>
    </section>
    <MONStationModal
      :open="showMONModal"
      :station="MONStation"
      :newStation="newStation"
      @update="updateStations"
      @close="close"
    />
    <div v-if="loading">
      <LoadingSpinner :spinnerMessage="'Updating stations...'" />
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../../_layouts/Authenticated.vue";
import MONStationModal from "./MONStationModal.vue";
import { api } from "@monolith/helpers";
import { mapGetters } from "vuex";
import { LoadingSpinner } from "@monolith/components";

export default {
  name: "MONPage",
  components: {
    Authenticated,
    MONStationModal,
    LoadingSpinner,
  },
  data() {
    return {
      showMONModal: false,
      newStation: false,
      MONStation: {},
    };
  },
  computed: {
    ...mapGetters({
      siteMap: "siteMap",
      companyName: "companyName",
      loading: "loading",
    }),
  },
  methods: {
    close() {
      this.showMONModal = false;
      this.newStation = false;
    },
    openMONModal(incoming, newStation = false) {
      this.newStation = newStation;
      if (newStation) {
        this.MONStation = { name: null, site: incoming, type: "mon" };
      } else {
        this.MONStation = { ...incoming };
      }
      this.showMONModal = !this.showMONModal;
    },
    async updateStations(typeOfUpdate, typeOfStation, incomingStation) {
      this.$store.dispatch("loading", true);
      let newStations = [];
      this.siteMap.forEach((site) => {
        if (site.site == incomingStation.site) {
          site.stations[typeOfStation].forEach((station) => {
            if (typeOfUpdate === "update") {
              if (station.name == incomingStation.name) {
                newStations.push(incomingStation);
              } else {
                newStations.push(station);
              }
            } else if (typeOfUpdate === "delete") {
              if (station.name != incomingStation.name) {
                newStations.push(station);
              }
            }
          });
        } else {
          site.stations[typeOfStation].forEach((station) => {
            newStations.push(station);
          });
        }
      });
      this.showMONModal = false;
      await api.post("/api/company/update_stations", {
        doc: newStations,
        station_type: "get_mon",
        site: incomingStation.site,
      });
      await this.$store.dispatch("initialSiteMap");
      this.$store.dispatch("loading", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  background-color: var(--primary-colour);
  padding: 1rem 2rem;
  margin: 2rem;
  border-radius: 10px;
  box-shadow: var(--box-shadow);

  h2 {
    text-transform: capitalize;
    margin-left: 0;
  }

  .unit-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .new {
      background-color: var(--action-colour);
      color: var(--secondary-text-colour);
      border-radius: 0.5rem;
      padding: 1rem 2rem;
      margin: 0.5rem;
      box-shadow: var(--box-shadow);
      cursor: pointer;
    }

    .unit {
      height: 8rem;
      margin: 0.5rem;
      padding: 1rem;
      width: 20%;
      box-shadow: var(--box-shadow);
      background-color: var(--tertiary-colour);
      border-radius: 10px;
      cursor: pointer;

      h4 {
        margin: 0.5rem 0;
        text-transform: capitalize;
      }

      .type-label {
        margin: 0.25rem 0;
        font-size: 0.8rem;
        color: var(--action-colour);
        opacity: 0.8;
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .main {
    padding: 1rem;
    border-radius: 0.5rem;
    margin: 1rem;

    .unit-container {
      flex-direction: column;
      align-items: center;

      .unit {
        width: 16rem;
      }
    }
  }
}
</style>
